<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="membership_breadcrumb" />
    </div>

    <div class="container">
      <div class="membership_header row d-flex justify-content-center">
        <div>
          <div class="overlay"><h1>PODOHOTEL MEMBERSHIP</h1></div>
          <img src="@/assets/images/Podohotel/membership_headerimage.jpg" />
        </div>
        <div class="gallerysoy_body_hedaer text-center col-lg-12 mt-5 mb-4">
          <h2><strong>멤버십</strong></h2>
        </div>
        <div class="col-lg-12 text-center mb-5" style="margin-bottom: 30px">
          <h4>포도호텔, 디아넥스 패키지 특전을 제공하는 온라인 무료 멤버십</h4>
          <p>이용 실적에 따라 특별한 혜택을 받아 보실 수 있습니다.</p>
        </div>
      </div>

      <div class="row d-flex justify-content-center mb-5">
        <div class="col-lg-6">
          <img src="@/assets/images/Podohotel/membership_bodyimage01.jpg" />
        </div>
        <div class="col-lg-6">
          <img src="@/assets/images/Podohotel/membership_bodyimage02.jpg" />
        </div>
      </div>

      <div class="row d-flex justify-content-center">
        <table class="utilization_table table table-borderless" style="table-layout: fixed">
          <tbody>
            <tr class="border-top border-bottom text-center" style="background-color: #f5f5f5">
              <td class="border-right">멤버십 등급</td>
              <td class="border-right">멤버십 기준</td>
              <td class="border-right">혜택</td>
              <td>등급 유지기간</td>
            </tr>
            <tr>
              <td class="border-bottom border-right text-center align-middle">
                <i class="icon-member im-classic"></i>Classic
              </td>
              <td class="border-bottom border-right text-center align-middle">회원가입 시</td>
              <td class="border-right">
                ∙ Membership Benefit<br />
                적용 패키지 온라인 예약 시<br />
                특전 제공<br />
                (등급별 자동 혜택)
              </td>
              <td rowspan="2" class="text-center align-middle">3년<br />(개인 정보 보관 기한 내 유지)</td>
            </tr>
            <tr class="border-bottom">
              <td class="border-right text-center align-middle"><i class="icon-member im-premier"></i>Premier</td>
              <td class="border-right text-center align-middle">온라인 예약 1회 이상 투숙 시</td>
              <td class="border-right">
                ∙ 온라인 예약 시, SK렌터카<br />
                최대 주중 85%, 주말 80%<br />
                할인 혜택 제공
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row d-flex justify-content-end mb-5">
        <p>
          *SK렌터카 할인 예약은 ‘My page-멤버십’에서 로그인 후 확인 가능합니다.<br />
          *SK렌터카 할인율은 시즌에 따라 상이합니다.
        </p>
      </div>

      <div class="row d-flex justify-content-center mb-5">
        <b-button type="button" class="signup_button" href="/p/AuthSignupTerm">가입하기</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Membership',
  data() {
    return {
      membership_breadcrumb: {
        toplink: 'HOME',
        present: '멤버십',
      },
    };
  },
  components: {Breadcrumb},
};
</script>

<style scoped>
.overlay {
  color: White;
  position: absolute;
  z-index: 12;
  top: 30%;
  left: 0;
  width: 100%;
  text-align: center;
}
.utilization_table {
  border-top: 3px solid;
}
.icon-member {
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: url(../../assets/images/Podohotel/icon_diamond.png) center center no-repeat;
  vertical-align: middle;
}
.im-classic {
  background-color: #acadaf;
  margin-right: 26px;
}
.im-premier {
  background-color: #524a3d;
  margin-right: 26px;
}
.signup_button {
  padding-top: 0;
  padding-bottom: 0;
  min-width: 177px;
  height: 59px;
  font-size: 17px;
  line-height: 59px;
  color: #fff;
}
</style>
